export const FLAG_GETTING_MANIFEST_ITINERARY =
  'FLAG_GETTING_MANIFEST_ITINERARY';
export const FLAG_GETTING_MANIFEST_ITINERARY_DETAIL =
  'FLAG_GETTING_MANIFEST_ITINERARY_DETAIL';
export const GET_MANIFEST_ITINERARY = 'GET_MANIFEST_ITINERARY';
export const GET_MANIFEST_ITINERARY_DETAIL = 'GET_MANIFEST_ITINERARY_DETAIL';
export const CLEAR_MANIFEST_ITINERARY = 'CLEAR_MANIFEST_ITINERARY';
export const CLEAR_MANIFEST_ITINERARY_DETAIL =
  'CLEAR_MANIFEST_ITINERARY_DETAIL';
